import { render, staticRenderFns } from "./PresencasPage.vue?vue&type=template&id=0439bf7a&scoped=true"
import script from "./PresencasPage.vue?vue&type=script&lang=js"
export * from "./PresencasPage.vue?vue&type=script&lang=js"
import style0 from "./PresencasPage.vue?vue&type=style&index=0&id=0439bf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439bf7a",
  null
  
)

export default component.exports